<script setup lang="ts">
import { onMounted, onUnmounted, computed } from "vue";
import { useAppStore } from "@/store/app";

const appStore = useAppStore();
const isActive = computed(() => {
  return appStore.isOverlayVisible;
})

const closeOverlay = () => {
  appStore.closeElements("all");
}

const handleEscape = (event: KeyboardEvent) => {
  if (event.key === "Escape" && isActive.value) {
    closeOverlay();
  }
};

onMounted(() => {
  window.addEventListener("keydown", handleEscape);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleEscape);
});

</script>

<template>
  <div 
    v-if="isActive"
    class="dsa__overlay" 
    @click="closeOverlay"
    ></div>
</template>


<style>
  .dsa__overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100vw;
    height: 100vh;
    z-index: 10001;
  }
</style>